const CSRF_STORAGE_KEY = 'csrf'
const CSRF_COOKIE_NAME = 'csrf'

function readCookieValue(name: string): string {
  if (typeof document === 'undefined') return ''
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : ''
}

/**
 * Returns a CSRF token suitable for the `X-CSRF-Token` header.
 *
 * Important: prefer the cookie value when present because the backend may rotate the CSRF cookie.
 * This function keeps localStorage in sync to avoid header/cookie mismatches.
 */
export function getCsrfToken(): string {
  if (typeof window === 'undefined') return ''

  const stored = localStorage.getItem(CSRF_STORAGE_KEY) || ''
  const fromCookie = readCookieValue(CSRF_COOKIE_NAME)

  if (fromCookie) {
    if (fromCookie !== stored) {
      localStorage.setItem(CSRF_STORAGE_KEY, fromCookie)
    }
    return fromCookie
  }

  return stored
}

